// Billing requests
export const TICKET_LIST = "TICKET_LIST";
export const TICKET_CREATE = "TICKET_CREATE";
export const TICKET_FILTER = "TICKET_FILTER";
export const TICKET_UPDATE = "TICKET_UPDATE";
export const INVOICE_CREATE = "INVOICE_CREATE";
export const INVOICE_UPDATE = "INVOICE_UPDATE";
export const CONSIGNMENT_CREATE = "CONSIGNMENT_CREATE";
export const CONFISCATION_CREATE = "CONFISCATION_CREATE";

// Billing success
export const TICKET_LIST_SUCCESS = "TICKET_LIST_SUCCESS";
export const TICKET_CREATE_SUCCESS = "TICKET_CREATE_SUCCESS";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";
export const INVOICE_CREATE_SUCCESS = "INVOICE_CREATE_SUCCESS";
export const INVOICE_UPDATE_SUCCESS = "INVOICE_UPDATE_SUCCESS";
export const CONSIGNMENT_CREATE_SUCCESS = "CONSIGNMENT_CREATE_SUCCESS";
export const CONFISCATION_CREATE_SUCCESS = "CONFISCATION_CREATE_SUCCESS";

// Billing failed
export const BILLING_REQUEST_FAILED = "TICKET_REQUEST_FAILED";
